import { useQueryStripeLink as useQueryStripeLinkCore } from '@heidi/commerce/data';
import { toast } from '@heidi/design-system/toast';
import { AxiosError } from 'axios';

export function useQueryStripeLink(enabled = true) {
  return useQueryStripeLinkCore(enabled, {
    onFetchError: (error) => {
      if (error instanceof AxiosError) {
        toast({
          tone: 'destructive',
          title: 'Error',
          description: JSON.stringify(error.response?.data),
        });
      }
    },
  });
}
